/**
 * Constructores de las rutas internas del sitio.
 *
 * Las URL son legibles a proposito: es lo comprometido en `SEO-01`. Estan aca y
 * no sueltas en los componentes para que cambiar el patron de una URL sea un
 * cambio de una linea y no una caceria por todo el proyecto.
 */

export const rutas = {
  inicio: () => '/',
  linea: (slug: string) => `/linea/${slug}`,
  categoria: (slug: string) => `/categoria/${slug}`,
  producto: (slug: string) => `/producto/${slug}`,
  busqueda: (termino: string) => `/buscar?termino=${encodeURIComponent(termino)}`,
  carro: () => '/carro',
  /** Datos, entrega y documento (CHK-03, CHK-04). Sin parametros: el pedido vive en el navegador. */
  checkout: () => '/checkout',
  /** A donde vuelve el comprador tras pagar en Webpay (PAG-02). */
  confirmacionPedido: (referencia: string) => `/checkout/confirmacion?referencia=${encodeURIComponent(referencia)}`,
  terminos: () => '/terminos',
  privacidad: () => '/privacidad',
  /** Historia, sala de ventas y taller. */
  nuestraTienda: () => '/nuestra-tienda',
  administracion: {
    /** Vista de entrada, fuera del armazon del panel. */
    acceso: () => '/admin/acceso',
    /** Cambio de la propia clave; obligatorio con la clave temporal. */
    clave: () => '/admin/clave',
    /** Pedir por correo el enlace para restablecer una clave olvidada. */
    recuperarClave: () => '/admin/recuperar',
    /** A donde lleva ese enlace; el token viaja en el fragmento (`#`). */
    restablecerClave: () => '/admin/restablecer',
    panel: () => '/admin',
    portada: () => '/admin/portada',
    productos: () => '/admin/productos',
    productoDetalle: (id: number) => `/admin/productos/${id}`,
    pedidos: () => '/admin/pedidos',
    busquedas: () => '/admin/busquedas',
    random: () => '/admin/random',
    despacho: () => '/admin/despacho',
    /** Correos que reciben el aviso de cada compra (MAIL-05). */
    avisosVenta: () => '/admin/avisos-compra',
    administradores: () => '/admin/administradores',
  },
} as const;

/** Agrega el numero de pagina a una ruta de listado, salvo en la primera. */
export function conPagina(ruta: string, pagina: number): string {
  if (pagina <= 1) return ruta;
  const separador = ruta.includes('?') ? '&' : '?';
  return `${ruta}${separador}pagina=${pagina}`;
}
